import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlycaUiCollapsablePanelComponent } from '../collapsable-panel.component';

@Component({
  selector: 'plyca-ui-collapsable-panel-demo',
  templateUrl: './collapsable-panel-demo.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiCollapsablePanelComponent]
})
export class PlycaUiCollapsablePanelDemoComponent {}
